export default function noop() {}



//////////////////
// WEBPACK FOOTER
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/~/d3-geo/src/noop.js
// module id = ../../../../d3-geo/src/noop.js
// module chunks = 3